import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";

import Loader from "../../../components/Loader/Loader";

const CustomerFacingDisplay = () => {
  const totalRef = useRef(0);

  const [loading, setLoading] = useState(false);
  const [statenew, setStateNew] = useState([]);
  const [dueAmount, setDueAmount] = useState(0);



  return (
    <>

      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col">
              <h3 className="page-title">Sales</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Sales</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="App"></div>
        {/* Header */}
        <div className="row">
          {/* Right Side Content */}

          {/* Item Grid */}
          <div className="card col-md-7">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table table-striped custom-table">
                      <thead>
                        <tr>
                          <th>Item Name</th>
                          <th>Price</th>
                          <th>Qty</th>
                          <th>Discount</th>
                          <th>Total</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {statenew.map((item, index) => (
                          <>
                            <tr key={item.modifyid}>
                              <td>
                                <td>
                                  {item.ItemName}({item.VariationName})
                                </td>
                              </td>

                              <td>
                                <input
                                  type="number"
                                  value={item.UnitPrice}
                                  className="form-control"
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  value={item.itemquantity}
                                  className="form-control"
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  value={item.itemdiscount}
                                  className="form-control"
                                />
                              </td>
                              <td>
                                {/* {calculateTotal(
                                  item.UnitPrice,
                                  item.itemquantity,
                                  item.itemdiscount
                                )} */}
                              </td>
                            </tr>
                          </>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Discount And Sale Card */}
          <div
            className="card col-md-5"
            style={{ marginLeft: "15px", width: "430px" }}
          >
            <div className="row mt-2">
              <div className="col-md-8 d-flex align-items-center">
                <label className="form-label">Sub Total:</label>
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  id="SubTotal"
                  name="SubTotal"
                  placeholder="Sub Total"
                  className="form-control"
                  value={totalRef.current.toFixed(2)}
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-md-6">
                <div className="amount-box">
                  <div className="amount-box-header">Total</div>
                  <div className="amount-box-content">
                    <div
                      className="amount-box-value"
                      data-speed="1000"
                      data-currency="$"
                      data-decimals="2"
                    >
                      {totalRef.current.toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="amount-box">
                  <div className="amount-box-header">Amount Due</div>

                  <div className="amount-box-content">
                    <div className="amount-box-value1">
                      {dueAmount.toFixed(2)}

                      {/* ${(totalRef.current - totalRef.current).toFixed(2)} */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerFacingDisplay;
